import ProductGrid from "../ProductGrid";
import ProductCardSkeleton from "./ProductCardSkeleton";

// grid of skeleton cards matching the product grid layout
export default function ProductGridSkeleton({ count = 8 }) {
  return (
    <ProductGrid>
      {Array.from({ length: count }).map((_, index) => (
        <ProductCardSkeleton key={index} />
      ))}
    </ProductGrid>
  );
}
